module.exports = __webpack_public_path__ + "img/icon_buzz_lines_left_yellow.81ebfb24.svg";